import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { ToneOfVoiceAnalyzerPopup } from './ToneOfVoiceAnalyzerPopup';

const POPUP_KEY = Symbol('TONE_OF_VOICE_ANALYZER');

export const useToneOfVoiceAnalyzerPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(POPUP_KEY, ToneOfVoiceAnalyzerPopup);
  });

  return useCallback(
    ({ generationTool, language, structureInstructionsData }) => {
      return new Promise((resolve) => {
        popups.openPopup(POPUP_KEY, {
          generationTool,
          language,
          structureInstructionsData,

          onSubmit: (result) => {
            popups.closePopup(POPUP_KEY);
            resolve(result);
          },
          onClose: () => {
            popups.closePopup(POPUP_KEY);
            resolve(null);
          },
        });
      });
    },
    [popups]
  );
};
